import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

// Asset imports
import Icon1 from "../../assets/social/Transparent Logo 2.png";
import MTN from "../../assets/social/MTN.png";
import Secure3D from "../../assets/social/3D.png";
import MasterCard from "../../assets/social/master-card.svg";
import Airtel from "../../assets/social/airtel.svg";
import Visa from "../../assets/social/visa.png";

// Thunks
import { useThunk } from "../../hooks/useThunk";
import { getTenantPaymentDetails } from "../../store";

// Utility imports
import showToast from "../../utils/toastNotifications";

const HeroSection = () => {
  const navigate = useNavigate();
  const [unitcode, setUnitCode] = useState("");
  const [getPaymentDetails, isLoading, error] = useThunk(
    getTenantPaymentDetails
  );

  const handleMakePayment = async (e) => {
    if (!unitcode) {
      showToast("error", "Please enter your unique code to proceed.");
      return;
    } else {
      const data = await getPaymentDetails({ unitcode });
      if (!data) {
        showToast(
          "error",
          "Failed to fetch payment details. Please try again."
        );
        return;
      }
      if (data.success == false) {
        showToast("error", data.error.message);
        return;
      }
      if (data.success == true) {
        // Navigate to the payment page with the unit code
        navigate(
          `/make-payment/${unitcode}/${data.response.data.checkoutSession.unitId}`
        );
      }
    }
  };

  return (
    <div className="px-0 xs:px-[28px] sm:px-[36px] md:px-[50px] lg:pl-[62px] lg:pr-[79px] pt-0 md:pt-[51px] pb-[00px] h-[400px] md:h-[450px] lg:h-[550px] relative overflow-hidden w-full">
      <div className="absolute top-[150px] sm:top-28 md:top-[53px] left-2 md:left-[61px] lg:left-[20px] xl:left-[100px] 2xl:left-28 z-0 flex flex-row md:flex-col items-center">
        <img
          src={MasterCard}
          alt="MasterCard"
          className="lg:w-[82.16px] lg:h-[95px] sm:w-[58px] sm:h-[65px] xs:w-12 xs:h-14 w-10 h-12 ml-0 xs:ml-6 lg:ml-[73px] relative sm:top-0 top-2 "
        />
        <img
          src={MTN}
          alt="MTN"
          className="lg:w-[104px] lg:h-[104px] sm:w-[68px] sm:h-[68px] xs:w-12 xs:h-12 w-10 h-10 mt-48 md:mt-[110px] mb-[105px]"
        />
      </div>
      <div className="absolute top-48 sm:top-[156px] md:top-14 right-0 md:right-[0px] xl:right-[79px] z-0  flex-row flex md:flex-col items-center justify-center">
        <img
          src={Secure3D}
          alt="3D Secure"
          className="lg:w-[76px] lg:h-[76px] xs:w-12 xs:h-12 sm:w-14 sm:h-14 w-10 h-10 mr-[-80px] xs:mr-[-97px] sm:mr-[-126px] md:mr-[60px] lg:mr-[112px]  mt-0 sm:mt-[-10px] md:mt-0"
        />
        <img
          src={Airtel}
          alt="Airtel Money"
          className="lg:w-[104px] lg:h-[104px] sm:w-[68px] xs:w-12 xs:h-12 w-10 h-10 sm:h-[68px] mt-[148px] md:mt-[116px] lg:mt-[120px] mb-[80px] mr-[40px] xs:mr-[76px] sm:mr-[96px] lg:mr-0"
        />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto text-center ">
        <h1 className="text-[37px] sm:text-[40px] md:text-[57px] lg:text-[77px] text-[#071952] font-alexandria leading-[100%] tracking-[-1%] font-[500]">
          Pay Your Rent Online
          <br />
          in Seconds.
        </h1>

        <p className="text-[#494949] text-level-7 sm:text-level-6 md:text-level-5 lg:text-[18px] font-poppins mt-6 xs:mb-0 mb-4 max-w-2xl mx-auto leading-snug tracking-normal word-spacing-sm font-[500]">
          No login or registration needed. Just enter your unique code to access
          your rent summary and make a secure payment.
        </p>

        <div className="xs:mt-[30px] md:mt-[59px] flex justify-center items-center gap-[5px] max-w- mx-auto">
          <input
            type="text"
            onChange={(e) => setUnitCode(e.target.value)}
            placeholder="Enter Your Unique Code"
            className=" w-full md:w-[380px] lg:w-[408px] h-10 md:h-[48px] lg:h-[64px] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#AAA9A9] bg-[#FFFFFF] pl-6 lg:pl-10 font-poppins font-[600] leading-[100%] tracking-[0%] focus:outline-none rounded-l-[3px]"
            style={{
              boxShadow: "0px 10px 15px 0px rgba(1, 115, 153, 0.2)",
            }}
          />
          <button
            onClick={handleMakePayment}
            className="text-white text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] leading-[100%] tracking-[0%] font-poppins font-[600] px-2 sm:px-4 md:px-6 lg:px-10 h-10 md:h-[48px] lg:h-[64px] w-[120px] sm:w-[160px] md:w-[180px] lg:w-[202px] rounded-[3px] hover:brightness-110 transition"
            style={{
              background:
                "linear-gradient(97.65deg, #60BBEE 0.33%, #0A72AD 93.35%)",
              boxShadow: "0px 10px 15px 0px rgba(1, 115, 153, 0.2)",
            }}
          >
            {isLoading ? (
              <ClipLoader size={18} color="#FFFFFF" />
            ) : (
              "Make Payment"
            )}
          </button>
        </div>
      </div>{" "}
      <div className="w-full flex justify-center">
        {" "}
        <img
          src={Visa}
          alt="Visa"
          className="lg:w-[104.12px] lg:h-[98px] sm:w-[80.12px] sm:h-[64px] w-12 h-12  mt-6     "
          style={{
            filter: "drop-shadow(0px 4px 4px rgba(205, 205, 205, 0.25))",
          }}
        />
      </div>
    </div>
  );
};

export default HeroSection;
